import * as React from "react"
import { Link } from "gatsby"

const CardInternalLink = ({ url, label }) => (
  <Link className="compact-action" to={url}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-4 w-4"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
      />
    </svg>
    <span className="text-xs">{label}</span>
  </Link>
)

export default CardInternalLink
